import _ from 'underscore';

export default class UserProductGroupSettings {
  constructor($scope, UserProductService) {
    function load_product_group_settings() {
      $scope.loading = true;
      UserProductService.get_product_group_settings(window.user_id).success(function(data) {
        _.each(data.product_groups, function(g) {
          g.settings = _.find(data.product_group_settings, {
            product_group_id: g.id
          }) || {
            spec_group_enabled: false,
            general_specs_enabled: false
          };
        });
        $scope.product_groups = data.product_groups;
        $scope.mixed_spec_groups = data.mixed_spec_groups;
        $scope.loading = false;
      });
    }

    $scope.tabs = [
      {
        title: 'Product Groups'
      },
      {
        title: 'Mixed Spec Groups'
      }
    ];

    $scope.set_selected_tab = function(index) {
      $scope.selected_tab = index;
    };

    $scope.update_settings = function(group, loader) {
      group[loader] = true;
      UserProductService.update_product_group_settings(window.user_id, group.id, group.settings).success(function(data) {
        group.settings = data.settings;
        group[loader] = false;
      });
    };

    $scope.update_auto_extend = function(group) {
      group.updating_auto_extend = true;
      var data = {
        id: group.id,
        auto_extend: group.auto_extend
      };
      UserProductService.update_spec_group(data).success(function(data) {
        if (data.success)
          group.updating_auto_extend = false;
      });
    };

    $scope.update_group_products = function(group) {
      group.updating_products = true;
      UserProductService.update_spec_group_products(window.user_id, group.id).success(function(data) {
        if (data.success)
          group.updating_products = false;
      });
    };

    $scope.init = function() {
      $scope.selected_tab = 0;
      load_product_group_settings();
    };

    $scope.init();
  }
}

UserProductGroupSettings.$inject = ['$scope', 'UserProductService'];



// WEBPACK FOOTER //
// ./front/js/admin/controllers/user-product-group-settings.ctrl.js